module.exports = __webpack_public_path__ + "img/Abschnittsleiter_THW.6c5e7b30.svg";